import { GenericService } from './generic.service';
import { ExternalPatientReferenceType } from '@/models';

export class ExternalPatientReferenceTypeService extends GenericService<ExternalPatientReferenceType> {

  constructor() {
    super('v1/external-patient-reference-types');
  }
}
